import Map from '@arcgis/core/Map';
import WebMap from '@arcgis/core/WebMap';
import { useEffect, useState } from 'react';
import { createMap, createWebMap } from '../jsapi/js-api-util';

// We need a default value so we dont have to do this: useMap({})
// when using the hook. use of "= defaultProps" rather than "= {}"
// also stops infinite render loop.
const defaultProps = {};
const useMap = ({
    webmapId,
    basemap,
    basemapId,
    ...rest
}: {
    webmapId?: string;
    basemap?: string;
    basemapId?: any;
} = defaultProps): Map | WebMap | undefined => {
    // Stops infinite render loop because state is only set once.
    // But does mean that map props cant be updated.
    const [data] = useState<any>({ ...rest });
    const [map, setMap] = useState<Map | WebMap | undefined>();

    useEffect(() => {
        let m: Map | WebMap;
        if (webmapId !== undefined) {
            m = createWebMap({ id: webmapId, ...data });
            setMap(m);
        } else if (basemapId !== undefined) {
            m = createMap({ basemapId, ...data });
            setMap(m);
        } else if (basemap !== undefined) {
            m = createMap({ basemap, ...data });
            setMap(m);
        }
        return () => {
            m && m.destroy();
        };
    }, [basemap, basemapId, data, webmapId]);

    return map;
};

export default useMap;
